import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';


window.initMediaGallery = function () {
    const containers = Array.from(document.querySelectorAll('.js-media-gallery'));

    containers.forEach((container) => {
        if (container.classList.contains('media-gallery-initialized')) return;
        container.classList.add('media-gallery-initialized');

        const wrapper = container.querySelector('.js-media-gallery-wrapper');
        const prevEl = container.querySelector('.js-media-gallery-prev');
        const nextEl = container.querySelector('.js-media-gallery-next');
        const gapDesktop = container.getAttribute('column-gap-desktop');
        const gapMobile = container.getAttribute('column-gap-mobile');
        const countDesktop = container.getAttribute('column-count-desktop');
        const countMobile = container.getAttribute('column-count-mobile');

        const pagination = container.getAttribute('show-pagination');
        const paginationEl = container.querySelector('.js-media-gallery-pagination');

        if (wrapper) {
            const slider = new Swiper(wrapper, {
                modules: [Navigation, Pagination],
                slidesPerView: countDesktop,
                spaceBetween: gapDesktop,
                slideToClickedSlide: true,
                navigation: {
                    prevEl,
                    nextEl,
                },
                pagination: pagination === 'true' && {
                    el: paginationEl,
                },
                breakpoints: {
                    0: {
                        slidesPerView: countMobile,
                        spaceBetween: gapMobile,
                    },
                    768: {
                        slidesPerView: countDesktop,
                        spaceBetween: gapDesktop,
                    },
                },
            });

            slider.init();
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
    initMediaGallery();
});